import { render, staticRenderFns } from "./MPzh.vue?vue&type=template&id=7db29783"
import script from "./MPzh.vue?vue&type=script&lang=js"
export * from "./MPzh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports